import React from 'react';
import { AddUniversal } from '@duxton-web/icons';
import { Button, Divider, Flex, Form, Input, Select } from '@duxton-web/ui';

import { SMART_CAMPAIGN_FORM_KEYS } from 'omega-rtc/constants/ucd';

const SmartCampaignCallToAction = ({
  callToActionOptions,
  handleAddNewItemInCallToAction,
  isHidden,
}) => {
  if (isHidden) {
    return <React.Fragment />;
  }

  return (
    <Form.Item
      required
      label="Call-to-Action"
      name={SMART_CAMPAIGN_FORM_KEYS.CALL_TO_ACTIONS}
      rules={[{ message: 'Please select a call-to-action', required: true }]}
    >
      <Select
        mode="multiple"
        options={callToActionOptions}
        placeholder="Select or enter call-to-action"
        dropdownRender={(menu) => (
          <React.Fragment>
            {menu}
            <Divider style={{ margin: '8px 0' }} />
            <Flex
              align="center"
              style={{ padding: '4px 8px', width: '100%', gap: 8 }}
            >
              <Form.Item
                style={{ flex: 1, marginBottom: 0 }}
                name={SMART_CAMPAIGN_FORM_KEYS.NEW_CALL_TO_ACTION}
              >
                <Input
                  placeholder="Please enter item"
                  onKeyDown={(e) => e.stopPropagation()}
                />
              </Form.Item>
              <Button
                type="text"
                icon={<AddUniversal />}
                onClick={handleAddNewItemInCallToAction}
              >
                Add item
              </Button>
            </Flex>
          </React.Fragment>
        )}
      />
    </Form.Item>
  );
};

export default SmartCampaignCallToAction;
